import {List, Map} from 'immutable';

export const apiDateFormat = 'YYYY-MM-DD';

const userEmailBadFormat = 472;

// This is compared with zxcvbn(password).guesses_log10
const mediumPasswordLevel = 10.0;
const strongPasswordLevel = 14.0;

const httpStatusCodeConflict = 409;

// Instead of starting the file upload progress bar from 0%, we start from 1% in order to make it show up sooner rather
// than later
const minFileUploadProgress = 0.01;
const datetimeSearchFieldsOptions = {
  dateBetween: 'Date Between...',
  exactDate: 'Exact Date',
  beforeDate: 'Before Date',
  within: 'Last...',
};
const datetimeWithinSearchFieldsOptions = {
  withinTheLastSevenDays: 7,
  withinTheLast30Days: 30,
  withinTheLast90Days: 90,
};
const datetimeSearchValueTypes = {
  to: 'to',
  from: 'from',
  exact: 'exact',
  before: 'before',
  within: 'within',
};
// TODO: Replace the following two constants with dynamically built `List` objects
// from the response of /api/v1/search
const datetimeSearchFields = List(['Date']);
const enumSearchFields = List(['Vote Up / Down']);
const stringSearchFieldActiveBackgroundColor = '#F1F1F1';
const finiteStringSearchFieldDefaultSelectedOptionKey = 'all_of';
const infiniteStringSearchFieldDefaultSelectedOptionKey = 'contains';
const stringSearchFieldDefaultOptionBorderRadius = '3px';

const booleanWidgetType = 'BooleanSearchWidget';
const numericWidgetType = 'NumericSearchWidget';
const datetimeWidgetType = 'DateSearchWidget';
const enumWidgetType = 'EnumSearchWidget';
const stringWidgetType = 'StringWidgetType';
const comboboxWidgetType = 'ComboboxWidgetType';

const comboboxWidgetTypeForCaller = 'Caller';
const radioButtonsWidgetTypeForVoting = 'RadioButtonsWidgetType ';
const keywordTopicWidgetType = 'KeywordTopicWidgetType';
const phoneWidgetType = 'PhoneWidgetType';

const numericSearchFieldNamesNeedSecondsToMinutesConversion = List(['Duration']);
const cardLabelSpanDefaultColor = '#707070';
export const scorecardResultScoreToHoverColor = Map({
  'n/a': '#1283C5',
  0: '#FF1100',
  1: '#FF7043',
  2: '#FF9C46',
  3: '#FFB74D',
  4: '#95C859',
  5: '#5ec855',
});

/** mime type list for client-side file type checking */
const allowedAudioMimeTypes = List([
  'audio/wav',
  'audio/x-wav',
  'audio/mp3',
  'audio/mpeg',
  'audio/x-ms-wmv',
  'audio/basic',
  'audio/x-ms-wma',
]);
// arful is nonstandard so probably does not work so adding .arf as well
const allowedVideoMimeTypes = List([
  'video/mp4',
  'video/webm',
  'video/x-ms-wma',
  'video/x-ms-wmv',
  'video/arful',
]);
const allowedFileExtensions = List(['.gsm', '.arf', '.m4a']);
const allowedMimeTypes = allowedAudioMimeTypes.concat(allowedVideoMimeTypes, allowedFileExtensions);

/** site-wide constants for the calls page */
const numberOfCallsPerPage = 25;

/** search input box / widgets related configurations */
const minimalNumberOfCharactersToTriggerSearch = 3;
const numberOfDigitsInNumericSearchFields = 2;
// number of milliseconds we wait before we fire a search request so that the ui has a chance to update
// it's rendering before the search results come back
const delayDurationForSearchWidgetToggles = 1000;

export enum SearchTypes {
  miAll = 'All',
  miPhone = 'Phone',
  miCaller = 'Caller',
  miContact = 'Contact',
  miCompany = 'Company',
  miCallStage = 'Call Stage',
  miCampaign = 'Campaign',
  miKeywords = 'Keywords',
  miAnnotations = 'Annotations',
}

// List of string constants that are used as `primaryText` values in the <MenuItem/> objects
// @deprecated
const searchTypes = {
  miAll: 'All',
  miPhone: 'Phone',
  miCaller: 'Caller',
  miContact: 'Contact',
  miCompany: 'Company',
  miCallStage: 'Call Stage',
  miCampaign: 'Campaign',
  miKeywords: 'Keywords',
  miAnnotations: 'Annotations',
};

const remainingIndicatorOptionType = 'remainingIndicator';

const adminWelcomeEmailTypes = {
  invite: 'invite',
  reminder: 'reminder',
};
const currentOpenLibraryDialog = {
  addToLibrary: 'addToLibrary',
  createOrUpdateLibrary: 'createOrUpdateLibrary',
};
const maxCharsInLibraryName = 25;

const reactSelectize = {
  dropdownDirection: {
    up: -1,
    down: 1,
  },
  dropdownHeight: 450,
  fieldHeight: 50,
};

const librarySearchType = {
  browse: 'Browse Calls',
  mostRecentlyAdded: 'Most Recently Added',
  search: 'Search Calls',
};

const comboboxElasticsearchNames = List(['Caller']);

const radioButtonsElasticsearchNames = List(['Voting']);

export const ALL_OF_VALUE = 'all_of';
export const KEYWORD_TOPIC = 'Keyword / Topic';
const keywordTopicElasticsearchNames = List([KEYWORD_TOPIC]);

export const departmentProfiles = {
  archivingProfile: {
    label: 'Call Archiving',
    pluralized: 'archivingProfiles',
    allowNull: true,
    flag: 'admin:archivingProfiles',
  },
  filterWordsProfile: {
    label: 'Keywords',
    pluralized: 'filterWordsProfiles',
    allowNull: false,
  },
  cardsProfile: {
    label: 'Scorecards',
    pluralized: 'cardProfiles',
    allowNull: false,
  },
};
export const EXTERNAL_SHARE_ALLOW_ALL = 'allow_all';
export const EXTERNAL_SHARE_PREVENT_ALL = 'prevent_all';
export const EXTERNAL_SHARE_DOMAIN_ONLY = 'allow_if_recipient_in_the_same_domain';

export enum featureFlags {
  adminKpis = 'admin_kpis',
  coachingChartForGoals = 'coaching_chart_for_goals',
  doNotRecordInternalMeetings = 'recording_bot_no_internal_meetings',
  downloadCall = 'download_call',
  enhancedManagerDash = 'enhanced_manager_dash',
  hasIntelligenceCalendar = 'i360_calendar',
  logoutTimer = 'logout_timer',
  newCoachHomepage = 'new_coach_homepage',
  recallBotEnabled = 'recall_bot_enabled',
  soneroBotEnabled = 'sonero_bot_enabled',
}

/**
 * List all the search_fields.type here
 */
export const SEARCH_FIELD_TYPES = {
  BOOLEAN: 'boolean',
  DATETIME: 'datetime',
  ENUM: 'enum',
  FINITE_STRING: 'finite_string',
  INFINITE_STRING: 'infinite_string',
  NESTED: 'nested',
  NUMERIC: 'numeric',
  PHONE: 'phone',
};

/**
 * List all the types of widgets available for search fields
 */
export const SEARCH_FIELD_WIDGET_TYPES = {
  COMBO_BOX: 'combo_box',
  RADIO_BUTTON: 'radio_button',
  KEYWORD_TOPIC: 'keyword_topic',
  ...SEARCH_FIELD_TYPES,
};

const ConstValues = {
  adminWelcomeEmailTypes: adminWelcomeEmailTypes,
  allowedAudioMimeTypes: allowedAudioMimeTypes,
  allowedMimeTypes: allowedMimeTypes,
  allowedVideoMimeTypes: allowedVideoMimeTypes,
  booleanWidgetType: booleanWidgetType,
  cardLabelSpanDefaultColor: cardLabelSpanDefaultColor,
  comboboxElasticsearchNames: comboboxElasticsearchNames,
  comboboxWidgetType: comboboxWidgetType,
  comboboxWidgetTypeForCaller: comboboxWidgetTypeForCaller,
  currentOpenLibraryDialog: currentOpenLibraryDialog,
  datetimeSearchFields: datetimeSearchFields,
  datetimeSearchFieldsOptions: datetimeSearchFieldsOptions,
  datetimeSearchValueTypes: datetimeSearchValueTypes,
  datetimeWithinSearchFieldsOptions: datetimeWithinSearchFieldsOptions,
  datetimeWidgetType: datetimeWidgetType,
  defaultWithinSearchFieldsOption: datetimeWithinSearchFieldsOptions.withinTheLastSevenDays,
  delayDurationForSearchWidgetToggles: delayDurationForSearchWidgetToggles,
  enumSearchFields: enumSearchFields,
  enumWidgetType: enumWidgetType,
  finiteStringSearchFieldDefaultSelectedOptionKey: finiteStringSearchFieldDefaultSelectedOptionKey,
  httpStatusCodeConflict: httpStatusCodeConflict,
  infiniteStringSearchFieldDefaultSelectedOptionKey:
    infiniteStringSearchFieldDefaultSelectedOptionKey,
  librarySearchType: librarySearchType,
  maxCharsInLibraryName: maxCharsInLibraryName,
  mediumPasswordLevel: mediumPasswordLevel,
  minFileUploadProgress: minFileUploadProgress,
  minimalNumberOfCharactersToTriggerSearch: minimalNumberOfCharactersToTriggerSearch,
  numberOfCallsPerPage: numberOfCallsPerPage,
  numberOfDigitsInNumericSearchFields: numberOfDigitsInNumericSearchFields,
  numericSearchFieldNamesNeedSecondsToMinutesConversion:
    numericSearchFieldNamesNeedSecondsToMinutesConversion,
  numericWidgetType: numericWidgetType,
  radioButtonsWidgetTypeForVoting: radioButtonsWidgetTypeForVoting,
  reactSelectize: reactSelectize,
  remainingIndicatorOptionType: remainingIndicatorOptionType,
  scorecardResultScoreToHoverColor: scorecardResultScoreToHoverColor,
  searchTypes: searchTypes,
  stringSearchFieldActiveBackgroundColor: stringSearchFieldActiveBackgroundColor,
  stringSearchFieldDefaultOptionBorderRadius: stringSearchFieldDefaultOptionBorderRadius,
  stringWidgetType: stringWidgetType,
  strongPasswordLevel: strongPasswordLevel,
  userEmailBadFormat: userEmailBadFormat,
  radioButtonsElasticsearchNames: radioButtonsElasticsearchNames,
  keywordTopicElasticsearchNames,
  keywordTopicWidgetType,
  phoneWidgetType,
};

// TODO probably better to use i18n for this
export const unsavedMessage = 'There are unsaved changes.  Are you sure you want to navigate away?';
export const requiredMessage = 'This field is required';
export const greaterThanMessage = count => `Must be greater than ${count}`;
export const errorCommunicating = 'There was a problem communicating with the server.';

export default ConstValues;

export enum SortDirection {
  ASC = 'asc',
  DESC = 'desc',
}
export const toggleSort = (sort: SortDirection) =>
  sort === SortDirection.ASC ? SortDirection.DESC : SortDirection.ASC;
